
function makeAppConfig() {
	const date = new Date();
	const year = date.getFullYear();

	const AppConfig = {
		brand: 'OrderAxe',
		user: 'AJM',
		year,
		layoutBoxed: false,               // true, false
		navCollapsed: false,              // true, false
		navBehind: false,                 // true, false
		fixedHeader: true,                // true, false
		sidebarWidth: 'middle',           // small, middle, large
		theme: 'light',                   // light, gray, dark
		colorOption: '33',                // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
		AutoCloseMobileNav: true,         // true, false. Automatically close sidenav on route change (Mobile only)
		productLink: 'https://themeforest.net/item/material-design-angular-2-admin-web-app-with-bootstrap-4/19421267'
	};

	return AppConfig;
}

export const APPCONFIG = makeAppConfig();
